'use client';

import { memo } from 'react';

import { AppleSignInButton } from '~/components/auth/AppleSignInButton';
import { GoogleSignInButton } from '~/components/auth/GoogleSignInButton';
import { type OAuthCustomState } from '~/components/auth/types';
import { type ButtonVariants } from '~/components/Button';

export type SSOProps = {
  /** Plugin-side context forwarded to both Google and Apple buttons. See
   * `OAuthCustomState` for the supported fields. */
  customState?: OAuthCustomState;
  /** Callback to navigate to OAuth waiting page with the generated id */
  onNavigate: (id: string) => void;
  /** Plugin name for analytics/tracking */
  pluginName: string;
  /** Button size — defaults to 'large' for backwards compatibility */
  size?: ButtonVariants['size'];
};

/**
 * SSO buttons composite component
 * Renders Google and Apple sign-in buttons
 */
export const SSO = memo(({ customState, onNavigate, pluginName, size }: SSOProps) => {
  return (
    <div className="flex w-full flex-col gap-2">
      <GoogleSignInButton customState={customState} onNavigate={onNavigate} pluginName={pluginName} size={size} />
      <AppleSignInButton customState={customState} onNavigate={onNavigate} pluginName={pluginName} size={size} />
    </div>
  );
});

SSO.displayName = 'SSO';
